import React from "react";
import { withStyles } from "@material-ui/core";
import Popover from "@material-ui/core/Popover";
import { HyBlastApproverNotificationIcon } from "icons";
import IconButton from "@material-ui/core/IconButton";
import { getApprovalRequests } from "relay/main";
import moment from "moment";
import { getAppPath } from "constants/path";
import { useHistory } from "react-router-dom";
import taskLoader from "./loadHyEventsRequests";

const styles = (theme) => ({
  container: {
    position: "relative",
    "&:hover path": {
      stroke: "#26bbed",
    },
  },
  count: {
    position: "absolute",
    background: "#F1414E",
    height: 18,
    width: 18,
    borderRadius: 18,
    fontSize: 12,
    top: 3,
    right: 8,
    color: "white",
    fontWeight: 600,
  },
  popoverBody: {
    maxHeight: 336,
    width: 320,
    background: "white",
    boxShadow: "2px 8px 25px rgba(0, 0, 0, 0.05),2px 2px 16px rgba(85, 85, 85, 0.05)",
  },
  backgroundColor: {
    height: 24,
    width: 24,
    background: "rgba(38, 187, 237, 0.1)",
    borderRadius: "2px",
  },
  header: {
    height: 60,
    borderBottom: "1px solid #EEEEEE",
    padding: "14px 20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  approvalText: {
    fontFamily: "Open Sans",
    fontSize: 20,
    lineHeight: "30px",
    fontWeight: 600,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  requestsCount: {
    height: 26,
    width: 26,
    background: "#f9f9f9",
    marginLeft: 8,
    fontFamily: "Open Sans",
    fontSize: 12,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  clearAll: {
    fontFamily: "Open Sans",
    fontSize: 14,
    lineHeight: "20px",
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed",
    },
  },
  listItem: {
    // height: 92,
    padding: "12px 16px",
    cursor: "pointer",
    "&:hover": {
      background: "#f4fbfd",
    },
  },
  dateStyle: {
    fontFamily: "Open Sans",
    fontSize: 12,
    lineHeight: "18px",
  },
  titleStyle: {
    fontFamily: "Open Sans",
    fontSize: 16,
    lineHeight: "20px",
    fontWeight: 600,
    margin: "4px 0px 8px 0px",
  },
  body: {
    maxHeight: 276,
    overflowY: "scroll",
  },
  iconContainer: {
    height: 24,
    width: 24,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  backgroundStyle: {
    background: "#f4fbfd",
  },
});

const NotificationBell = withStyles(styles)(
  ({ classes, orgId, hyBlastApprovalsRequestCallback, hyEvents }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const [requests, setRequests] = React.useState([]);
    // const [newRequest, setNewRequest] = React.useState()
    const history = useHistory();
    React.useEffect(() => {
      //load all the appoval request for the current user
      if (hyEvents) {
        loadHyEventsRequests();
      } else {
        loadMyApprovalRequests();
      }
      const interval = setInterval(hyEvents ? loadHyEventsRequests : loadMyApprovalRequests, 6000);
      return () => {
        clearInterval(interval);
      };
    }, [1]);
    const loadMyApprovalRequests = async () => {
      try {
        let res = await loadApprovalRequests("my");
        setRequests(res);
        hyBlastApprovalsRequestCallback(res);
      } catch (err) {
        console.log("Error: ", err);
      }
    };

    const loadApprovalRequests = async (type) => {
      try {
        let res = await getApprovalRequests(orgId, type);
        if (res && res.approvalRequests) {
          return res.approvalRequests.edges;
        } else {
          return [];
        }
      } catch (err) {
        console.log("Error: ", err);
      }
    };

    const loadHyEventsRequests = async () => {
      try {
        let resp = await taskLoader(orgId);
        let t = resp.approvalRequests ? resp.approvalRequests.edges || [] : [];
        setRequests(t);
      } catch (err) {
        console.log("task err : ", err);
      }
    };

    //For Hyevents
    if (hyEvents && typeof window.parent.approvalNotif === "function" && requests.length) {
      window.parent.approvalNotif(requests, requests.length);
      let new_request = requests.map((e) => e.node.hyevent.id).toString();
      if (localStorage.getItem("my_approver_requests") !== new_request)
        localStorage.setItem("my_approver_requests", new_request);
    }

    const handleClick = (event) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    const getDifference = (time) => {
      let currentDate = new moment();
      let diff = time.diff(currentDate);
      let value = "Expired";
      if (diff > 0) {
        diff = time.diff(currentDate, "seconds");
        if (diff > 59) {
          diff = time.diff(currentDate, "minutes");
          if (diff > 59) {
            diff = time.diff(currentDate, "hours");
            if (diff > 23) {
              diff = time.diff(currentDate, "days");
              // if (diff > 6) {
              //   diff = time.diff(currentDate, 'weeks');
              //   return `Expires in ${diff} ${diff > 1 ? 'weeks' : 'week'}`
              // } else {
              return `Expires in ${diff} ${diff > 1 ? "days" : "day"}`;
              // }
            } else {
              return `Expires in ${diff} ${diff > 1 ? "hours" : "hour"}`;
            }
          } else {
            return `Expires in ${diff} ${diff > 1 ? "mins" : "min"}`;
          }
        } else {
          return `Expires in ${diff} ${diff > 1 ? "seconds" : "second"}`;
        }
      }
      return value;
    };

    const handleClickItem = (item) => {
      const appPath = getAppPath(item.node.propertyId);
      if (hyEvents) {
        return window.open(appPath + `/event/${item.node.hyevent.id}`, "_blank");
      } else {
        return window.open(appPath + `/blast/${item.node.eblastId}/edit`, "_blank");
      }
    };

    const handleClickAll = () => {
      const appPath = getAppPath();
      if (hyEvents) {
        return history.push(appPath + "/events/approvals/my-approval");
      } else {
        return history.push(appPath + "/blast/approvals/my-approval");
      }
    };

    const renderRequest = (item, index) => {
      const name = hyEvents ? item.node.hyevent.title : item.node.eblastName;
      const time = hyEvents ? item.node.hyevent.publishAt : item.node.scheduledTime;
      return (
        <div className={classes.listItem} key={index} onClick={handleClickItem.bind(this, item)}>
          <div className={classes.dateStyle}>
            {moment(item.node.createdAt).format("DD MMM YYYY, hh:mmA")}
          </div>
          <div className={classes.titleStyle}>{name}</div>
          <div className={classes.dateStyle}>{getDifference(moment(time))}</div>
        </div>
      );
    };

    const open = Boolean(anchorEl);
    const id = open ? "hyBlast-approvers-notification" : undefined;
    return (
      <>
        <IconButton onClick={handleClick} className={classes.container}>
          <div className={`${classes.iconContainer} ${open && classes.backgroundStyle}`}>
            <HyBlastApproverNotificationIcon />
          </div>
          {!open && requests.length ? <div className={classes.count}>{requests.length}</div> : open}
        </IconButton>
        <Popover
          id={id}
          open={open}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
          classes={{
            paper: classes.popoverBody,
          }}
        >
          <div>
            <div className={classes.header}>
              {requests.length == 0 ? (
                <div className={classes.approvalText}>No Approval Request.</div>
              ) : (
                <>
                  <div className={classes.approvalText}>
                    Approval Queue <div className={classes.requestsCount}>{requests.length}</div>
                  </div>
                  <div className={classes.clearAll} onClick={handleClickAll}>
                    See All
                  </div>
                </>
              )}
            </div>
            <div className={classes.body}>
              {requests && requests.length > 0 && requests.map(renderRequest)}
            </div>
          </div>
        </Popover>
      </>
    );
  }
);

export default ({ show, ...props }) => {
  if (show) {
    return <NotificationBell {...props} />;
  }
  return null;
};
